import React, { useContext, useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actionTypes from "../../store/Actions/actions";
import { LocalesContext } from "../../context/localesContext";
import closeCrossBlack from "../../assets/images/closeCrossBlack.svg";
import SearchIcon from "../../assets/images/search.svg";
import NavigationModal from "./NavigationSettings";

const Navbar = ({
  mobileView,
  newLayoutTitle,
  onChangeTitle,
  createNewBtn,
  enableWidthForRow,
  width,
  saveAsBlock,
}) => {
  const dispatch = useDispatch();
  const {
    layoutTitle,
    layoutList,
    anchorNavigation,
    navigationAlign,
    hamburgerColor,
    hamburgerMenu,
    navClass,
    navigationSearch,
    navigationStyle,
    canvasStyle,
  } = useSelector((state) => state.present);
  const searchContainerRef = useRef(null);
  const { changeLocale } = useContext(LocalesContext);
  const [searchToggle, setSearchToggle] = useState(false);
  const [deskBurgerActive, setDeskBurgerActive] = useState(false);
  const [menuHover, setMenuHover] = useState(null);
  const [mobileBurgerActive, setMobileBurgerActive] = useState(false);
  const [navigationSettings, setNavigationSettings] = useState(false);
  const headerFlimpRef = useRef(null);
  const mobileHeaderFlimpRef = useRef(null);

  const handleClick = () => {
    if (searchContainerRef.current) {
      searchContainerRef.current.focus();
    }
  };
  const tabsList =
    anchorNavigation && anchorNavigation.enable
      ? anchorNavigation.tabs
      : layoutList;

  const changeLayoutState = (item, index) => {
    if (anchorNavigation.enable) {
      const element = document.getElementById(item.link);
      if (element)
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
    } else {
      const title = item[0];
      const selectedLayout = layoutList.filter((item, ind) => {
        if (item[0] === title) {
          return item;
        }
      });
      dispatch(
        actionTypes.layout({ titleLayout: title, layout: selectedLayout[0][1] })
      );
      dispatch(actionTypes.set_default_page(title));
      changeLocale(index);
    }
  };

  const toggleSearch = () => {
    setSearchToggle(!searchToggle);
  };

  const getHamburgerStyle = () => {
    return hamburgerColor
      ? {
        color: `rgba(${hamburgerColor.r}, ${hamburgerColor.g}, ${hamburgerColor.b}, ${hamburgerColor.a})`,
        marginLeft: "10px",
        marginRight: "10px",
      }
      : {};
  };

  const MenuIcon = (props) => {
    if (layoutList.length > 1) {
      return (
        <i
          style={getHamburgerStyle()}
          onClick={() =>
            props.deviceType == "mobile"
              ? setMobileBurgerActive(!mobileBurgerActive)
              : setDeskBurgerActive(!deskBurgerActive)
          }
          className="menuBurger fas fa-bars"
        ></i>
      );
    }
    return null;
  };

  const SettingIcon = () => {
    return (
      <span
        style={{
          display: saveAsBlock ? "none" : "block",

          position:
            !mobileView & !enableWidthForRow || width !== "100%"
              ? "absolute"
              : !mobileView & enableWidthForRow || width == "100%"
                ? "absolute"
                : "absolute",
          left:
            !mobileView & enableWidthForRow || !mobileView & (width == "100%")
              ? "5px"
              : "-20px",
          top:
            anchorNavigation.enable & (anchorNavigation.tabs.length < 1) ||
              layoutList.length < 1
              ? "8px"
              : layoutList.length > 1
                ? ""
                : "5px",
          zIndex: 4,
        }}
        onClick={() => {
          setNavigationSettings(true);
        }}
        className={`settingIcon eleventh-step`}
      >
        <i
          id={"settingsIcon"}
          onClick={() => {
            setNavigationSettings(true);
          }}
          className="fas fa-cog"
        ></i>
        <span className="tooltipSetting">Navigation settings</span>
      </span>
    );
  };

  const SearchSection = () => {
    return (
      <div
        ref={searchContainerRef}
        onClick={handleClick}
        style={{
          width: "fit-content",
          order: navigationAlign == "right" ? -1 : 2,
          position: mobileView
            ? !hamburgerMenu.menu & mobileHeaderFlimpRef.current &&
              mobileHeaderFlimpRef.current.getBoundingClientRect().width < 1200
              ? "absolute"
              : "relative"
            : mobileView
              ? !hamburgerMenu.menu &
                (headerFlimpRef.current.getBoundingClientRect().width < 1200)
                ? "absolute"
                : "relative"
              : "",
          right:
            !hamburgerMenu.menu & (navigationAlign == "right") ? "" : "0px",
          left: !hamburgerMenu.menu & (navigationAlign == "right") ? "0px" : "",
          backgroundColor: "rgb(237, 231, 231)",
          margin: "4px",
        }}
        className={`searchSection${searchToggle ? " active" : ""}`}
      >
        <img
          onClick={toggleSearch}
          src={searchToggle ? closeCrossBlack : SearchIcon}
          alt="Search Toggle"
        />
        <div
          className="searchBarInput"
          style={
            !hamburgerMenu.menu &
              (navigationAlign == "left") &
              (layoutList.length < 2)
              ? { left: "0px" }
              : !hamburgerMenu.menu &
                (navigationAlign == "right") &
                (layoutList.length < 2)
                ? { right: "0px" }
                : (navigationAlign == "right") & !hamburgerMenu.menu
                  ? { left: "0px" }
                  : (navigationAlign == "left") & !hamburgerMenu.menu
                    ? { right: "0px" }
                    : hamburgerMenu.menu & (navigationAlign == "left")
                      ? { left: "0px" }
                      : hamburgerMenu.menu & (navigationAlign == "right")
                        ? { right: "0px" }
                        : { right: "0px" }
          }
        >
          <input placeholder="Search here" type="text" />
        </div>
      </div>
    );
  };

  const getBackgroundStyle = (property, isActive) => {
    if (property == "navigationBgColor") {
      return `rgba(${navigationStyle[property]?.r},${navigationStyle[property]?.g},${navigationStyle[property]?.b},${navigationStyle[property]?.a})`;
    } else {
      return isActive
        ? `rgba(${navigationStyle[property]?.r},${navigationStyle[property]?.g},${navigationStyle[property]?.b},${navigationStyle[property]?.a})`
        : null;
    }
  };

  const getTextStyle = (currentPage, isActive) => {
    return {
      fontSize: navigationStyle?.textFontSize || 14,
      fontFamily: navigationStyle?.textFontFamily || "Montserrat",
      textDecoration: navigationStyle?.textUnderlined ? "underline" : "none",
      fontStyle: navigationStyle?.textItalic ? "italic" : "normal",
      color: isActive
        ? navigationStyle?.textActiveColor
          ? `rgba(${navigationStyle.textActiveColor.r},${navigationStyle.textActiveColor.g},${navigationStyle.textActiveColor.b},${navigationStyle.textActiveColor.a})`
          : "#26a9e1"
        : menuHover === currentPage && navigationStyle?.textHoverColor
          ? `rgba(${navigationStyle.textHoverColor.r},${navigationStyle.textHoverColor.g},${navigationStyle.textHoverColor.b},${navigationStyle.textHoverColor.a})`
          : navigationStyle?.textColor
            ? `rgba(${navigationStyle.textColor.r},${navigationStyle.textColor.g},${navigationStyle.textColor.b},${navigationStyle.textColor.a})`
            : "#0c3254",
    };
  };

  const getMenuItem = (item, index) => {
    let name = "";
    if (anchorNavigation.enable) {
      name = item.name;
    } else {
      name = item[0];
    }
    if (
      (!anchorNavigation.enable && layoutList.length > 1) ||
      anchorNavigation.enable
    )
      return (
        <div
          key={index}
          onClick={() => {
            changeLayoutState(item, index);
            setDeskBurgerActive(false);
            setMobileBurgerActive(false);
          }}
          className={`menu ${layoutTitle === name ? "show" : "hidden"}`}
          style={{
            ...getTextStyle(name, layoutTitle === name),
            backgroundColor:
              navigationStyle &&
              getBackgroundStyle("currentPageBgColor", layoutTitle === name),
          }}
          onMouseEnter={() => setMenuHover(name)}
          onMouseLeave={() => setMenuHover(null)}
        >
          <a style={{ fontWeight: "normal" }}>{name}</a>
        </div>
      );
  };

  return (
    <>
      {mobileView ? (
        <>
          <SettingIcon />
          <div
            className={
              anchorNavigation.sticky && anchorNavigation.enable
                ? "sticky-navbar"
                : "nav-bar"
            }
            style={{
              backgroundColor:
                navigationStyle && getBackgroundStyle("navigationBgColor")
                  ? getBackgroundStyle("navigationBgColor")
                  : "transparent",
              overflowX: "visible",
              overflowY: "visible",
              justifyContent: "center",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: `${navigationAlign}`,
                justContent: "center",
                alignItems: "center",
                width: "100%",
                padding: "7px",
              }}
            >
              {(navigationAlign == "left" || navigationAlign == "center") &
                navigationSearch ? (
                <>
                  <MenuIcon deviceType="mobile" /> <SearchSection />
                </>
              ) : navigationSearch ? (
                <>
                  <SearchSection />
                  <MenuIcon deviceType="mobile" />{" "}
                </>
              ) : (
                <MenuIcon deviceType="mobile" />
              )}
            </div>
            <div
              style={{
                width: "100%",
                justifyContent:
                  navigationAlign && navigationAlign
                    ? navigationAlign
                    : "right",
                display: mobileBurgerActive ? "flex" : "none",
              }}
              className={`headerFlimp`}
            >
              <div
                className={`${navClass} activeBurgerMenu`}
                style={
                  navigationStyle && navigationStyle.pageMenuBgColor
                    ? {
                      width: "100%",
                      display: mobileBurgerActive ? "flex" : "none",
                      alignSelf: navigationAlign || "right",
                      flexDirection: "row",
                      background: `rgba(${navigationStyle.pageMenuBgColor.r},${navigationStyle.pageMenuBgColor.g},${navigationStyle.pageMenuBgColor.b},${navigationStyle.pageMenuBgColor.a})`,
                    }
                    : {
                      width: "100%",
                      display: mobileBurgerActive ? "flex" : "none",
                      alignSelf: navigationAlign || "right",
                      alignItems: "center",
                      flexDirection: "row",
                    }
                }
              >
                {tabsList.map((item, index) => getMenuItem(item, index))}
              </div>
            </div>
            {navigationSettings && (
              <NavigationModal
                hideSettings={() => {
                  setNavigationSettings(false);
                }}
                pageTitle={newLayoutTitle}
                onChangeTitle={onChangeTitle}
                createNewBtn={createNewBtn}
              ></NavigationModal>
            )}
          </div>
        </>
      ) : (
        <div
          style={{
            position:
              anchorNavigation.sticky && anchorNavigation.enable
                ? "sticky"
                : "relative",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor:
              navigationStyle && getBackgroundStyle("navigationBgColor")
                ? getBackgroundStyle("navigationBgColor")
                : "transparent",
            zIndex: 4,
            top:
              anchorNavigation.sticky && anchorNavigation.enable ? "0px" : "",
          }}
        >
          <SettingIcon />
          <div
            className={
              anchorNavigation.sticky && anchorNavigation.enable
                ? "sticky-navbar"
                : "nav-bar"
            }
            style={{
              backgroundColor:
                navigationStyle && getBackgroundStyle("navigationBgColor")
                  ? getBackgroundStyle("navigationBgColor")
                  : "transparent",
              overflowX: !hamburgerMenu.menu ? "auto" : "visible",
              overflowY: "visible",
              display: "flex",
              width: "100%",
              maxWidth: enableWidthForRow ? width : "100%",
              justifyContent:
                headerFlimpRef.current &&
                  headerFlimpRef.current.getBoundingClientRect().width > 1200
                  ? "left"
                  : navigationAlign,
              alignItems: "center",
              padding: hamburgerMenu.menu ? "10px" : "0px",
              paddingLeft: hamburgerMenu.menu ? "10px" : "0px",
              paddingRight: hamburgerMenu.menu ? "10px" : "0px",
            }}
          >
            <div
              style={{
                justifyContent:
                  headerFlimpRef.current &&
                    headerFlimpRef.current.getBoundingClientRect().width > width
                    ? "left"
                    : navigationAlign,
                display: "flex",
                width: "100%",
                position: "relative",
              }}
              className={
                (enableWidthForRow ? "headerFlimp EnableWidthForRows " : "") +
                `headerFlimp display`
              }
            >
              {hamburgerMenu.menu ? (
                <div
                  className={`${navClass} ${hamburgerMenu.menu ? " deskBurgerEnabled" : ""
                    } ${hamburgerMenu.menu ? " activeBurgerMenu " : ""}`}
                  style={
                    navigationStyle && navigationStyle.pageMenuBgColor
                      ? {
                        display: deskBurgerActive == true ? "flex" : "none",
                        alignSelf: navigationAlign || "right",
                        flexDirection: "row",
                        background: `rgba(${navigationStyle.pageMenuBgColor.r},${navigationStyle.pageMenuBgColor.g},${navigationStyle.pageMenuBgColor.b},${navigationStyle.pageMenuBgColor.a})`,
                        right: navigationAlign == "right" ? "0px" : "auto",
                      }
                      : {
                        display: deskBurgerActive == true ? "flex" : "none",
                        alignSelf: navigationAlign || "right",
                        alignItems: "center",
                        flexDirection: "row",
                      }
                  }
                >
                  {tabsList.map((item, index) => getMenuItem(item, index))}
                </div>
              ) : (
                <div
                  className={`${navClass}`}
                  ref={headerFlimpRef}
                  style={{
                    ...(navigationStyle && navigationStyle.pageMenuBgColor
                      ? {
                        display: "-webkit-inline-flex",
                        alignSelf: navigationAlign || "right",
                        flexDirection: "row",
                        background: `rgba(${navigationStyle.pageMenuBgColor.r},${navigationStyle.pageMenuBgColor.g},${navigationStyle.pageMenuBgColor.b},${navigationStyle.pageMenuBgColor.a})`,
                        overflow: 'auto'
                      }
                      : {
                        display: "flex",
                        alignSelf: navigationAlign || "right",
                        alignItems: "center",
                        flexDirection: "row",
                        overflow: 'auto'
                      }),
                  }}
                >
                  {tabsList.map((item, index) => getMenuItem(item, index))}
                </div>
              )}

              {hamburgerMenu.menu &&
                hamburgerMenu.label &&
                navigationAlign == "right" ? (
                <span style={getHamburgerStyle()} className="burgerLabel">
                  {hamburgerMenu.label}
                </span>
              ) : (
                ""
              )}
              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  display: "flex",
                  alignSelf: "center",
                  order: navigationAlign == "left" ? 0 : 2,
                }}
              >
                {hamburgerMenu.menu && (
                  <>
                    <i
                      style={getHamburgerStyle()}
                      onClick={() => setDeskBurgerActive(!deskBurgerActive)}
                      className="menuBurger deskTopBurger fas fa-bars"
                    ></i>
                    {hamburgerMenu.label && navigationAlign !== "right" ? (
                      <span style={getHamburgerStyle()} className="burgerLabel">
                        {hamburgerMenu.label}
                      </span>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </div>

              {navigationSearch & hamburgerMenu.menu ? <SearchSection /> : ""}
            </div>

            {navigationSettings && (
              <NavigationModal
                hideSettings={() => {
                  setNavigationSettings(false);
                }}
                pageTitle={newLayoutTitle}
                onChangeTitle={onChangeTitle}
                createNewBtn={createNewBtn}
              ></NavigationModal>
            )}
          </div>
          {navigationSearch & !hamburgerMenu.menu ? <SearchSection /> : ""}
        </div>
      )}
    </>
  );
};

export default Navbar;
